import { CommonAPIService } from './CommonHandler';

export class UserAPIService {
  constructor() {
    this.CommonAPIService = new CommonAPIService();
  }

  getUserList(router) {
    const url = '/api/users';
    return this.CommonAPIService.getCall(url, '', router);
  }

  createUser(parms, router) {
    const url = '/api/users';
    return this.CommonAPIService.postCall(url, parms, router);
  }

  getUserById(user_id, router) {
    const url = `/api/users/${user_id}`;
    return this.CommonAPIService.getCall(url, '', router);
  }

  updateUser(user_id, parms, router) {
    const url = `/api/users/${user_id}`;
    return this.CommonAPIService.putCall(url, parms, router);
  }

  checkUsername(username, router) {
    const url = `/api/users/${username}/check`;
    return this.CommonAPIService.getCall(url, '', router);
  }

  validateUser(link, router) {
    const url = `/api/users/${link}/verify`;
    return this.CommonAPIService.getCall(url, '', router);
  }

  changeUserRankTo(user_id, rank_id, promote, router){
    const url = `/api/users/${user_id}/${rank_id}/change`
    return this.CommonAPIService.postCall(url, {promote}, router)
  }

  getCompletedRanksForUser(user_id, router){
    const url = `/api/users/completed/${user_id}`
    return this.CommonAPIService.getCall(url, '', router)
  }

  resetPassword(parms, router) {
    const url = `/api/auth/reset`;
    return this.CommonAPIService.postCall(url, parms, router);
  }

  changePassword(parms, router) {
    const url = `/api/auth/change`;
    return this.CommonAPIService.postCall(url, parms, router);
  }
}

export default UserAPIService;
